"use client";

import {
  FooterCountryToggle,
} from "@/ui/components/navigation/Footer/FooterCountryToggle";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { usePathname } from "apps/website/i18n/navigation";

import type { TCountryToggleProps } from "./CountryToggle.config";
import { navigateToLocale } from "./CountryToggle.utils";

export const CountryToggle = ({ className }: TCountryToggleProps) => {
  const isEnabled = useFeatureFlagEnabled("international-translations");
  const pathname = usePathname();

  if (!isEnabled) {
    return null;
  }

  return (
    <FooterCountryToggle
      className={className}
      onCountryChange={(locale) => navigateToLocale(pathname, locale)}
    />
  );
};

CountryToggle.displayName = "CountryToggle";
